import { useMemo } from 'react';
import moment from 'moment';
import useSelectedFilterSet from '../../../../../state/filters/hooks/useSelectedFilterSet';
import { ForecastFiltersContext } from '../../../../../state/filters/contexts';
import { CALENDAR_COLORS } from '../CalendarView.style';
import { SHORT_DATE_FORMAT } from 'common/constants/constants';

const useCustomDatesLegends = ({ monthsInView }) => {
  const selectedFilterSet = useSelectedFilterSet(ForecastFiltersContext);
  const dueDate = selectedFilterSet?.metadata?.due_date;

  const isDateClickable = date => !monthsInView.includes(moment(date).month());

  const customDatesLegends = useMemo(() => {
    const legends = [
      {
        date: moment(),
        color: CALENDAR_COLORS.TODAY,
        title: 'Today'
      },
      dueDate && {
        date: moment(dueDate),
        color: CALENDAR_COLORS.DUE_DATE,
        title: `Target Date
            (${moment(dueDate).format(SHORT_DATE_FORMAT)})`
      }
    ]
      .filter(Boolean)
      .map(legend => ({
        ...legend,
        isClickable: isDateClickable(legend.date)
      }));

    return legends;
  }, [monthsInView, dueDate]);

  return customDatesLegends;
};

export default useCustomDatesLegends;
